<template>
  <v-footer class="black footerPos">
    <v-layout row wrap align-center justify-center>
      <div @click="language = 'fi'" class="pr-2">
        <img src="public\images\flags\suo.png" class="flags icon-transform-1">
      </div>
      <div @click="language = 'sv'" class="pr-2">
        <img src="public\images\flags\sve.png" class="flags icon-transform-1">
      </div>
      <div @click="language = 'en'" class="pr-2">
        <img src="public\images\flags\eng.png" class="flags icon-transform-1">
      </div>
      <!-- <v-spacer></v-spacer>
      <div style="max-width:50vw;">
        <marquee-text
          :repeat="10"
        >Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.</marquee-text>
      </div> -->

      <v-spacer></v-spacer>
      <div>
        <a class="white--text" href="https://electrowaves.fi">Electro Waves Oy</a>
        <v-icon class="blue--text">copyright</v-icon>2019
      </div>
    </v-layout>
  </v-footer>
</template>

<script>
import MarqueeText from "vue-marquee-text-component";
export default {
  name: "CFooter",
  data() {
    return {
      flags: [
        { lang: "fi", img: "public/images/flags/suo.png" },
        { lang: "sv", img: "public/images/flags/sve.png" },
        { lang: "en", img: "public/images/flags/eng.png" }
      ]
    };
  },
  components: {
    MarqueeText
  }
};
</script>

<style>
.footerPos {
  bottom: 0px;
  width: 100%;
  position: absolute;
}

.flags {
  max-width: 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue